import React from 'react';
import type { MRT_Row } from '@talentmesh/table';
import { TeamMember } from '@/Models/TeamMember';
import MemberManagementButton from './MemberManagementButton';

export interface TeamMemberActionsCellProps {
    row: MRT_Row<TeamMember>;
}

function TeamMemberActionsCell({ row }: TeamMemberActionsCellProps): React.JSX.Element | null {
    if (row.original.role === 'Owner') {
        return null;
    }
    return <MemberManagementButton row={row} />;
}

export default TeamMemberActionsCell;
